import { StaticImage } from 'gatsby-plugin-image';
import { Heading } from '@hover/blueprint';
import React from 'react';
import { IWebinarDetailSection } from '../interfaces/IWebinarDetailSection';

export const WEBINAR_DETAIL_SECTIONS: IWebinarDetailSection[] = [
  {
    title: 'PANELISTS',
    header: 'Meet today’s speakers',
    body: (
      <>
        <Heading as="p" marginBottom={500} isDisplay size={200}>
          Super fun part: Use the design tools in our app to change colors, roof
          style, siding type, windows and more with real products on your home’s
          3D model. Pretty cool, huh?
        </Heading>
        <Heading as="p" marginBottom={200} isDisplay size={200}>
          Collaborate with your contractor on design decisions, material
          selections, and other project plans.
        </Heading>
      </>
    ),
    id: 0,
    image: (
      <StaticImage
        loading="lazy"
        placeholder="blurred"
        alt="faster measurements"
        src="../assets/images/how_does_it_work_designing.png"
        width={378}
        height={560}
      />
    ),
  },
  {
    title: 'measurements',
    header: 'What the viewers will learn in this webinar',
    body: (
      <>
        <Heading as="p" marginBottom={500} isDisplay size={200}>
          Super accurate and complete roof and elevation data for any property
          from just 8 smartphone photos.
        </Heading>
        <Heading as="p" marginBottom={200} isDisplay size={200}>
          Invite policyholders to photograph their home to expedite claims even
          more. Spend less time on-site and resolve more claims per day.
        </Heading>
      </>
    ),
    id: 1,
    image: (
      <StaticImage
        loading="lazy"
        placeholder="blurred"
        alt="faster measurements"
        src="../assets/images/webinar_detail_2.png"
        width={480}
        height={480}
      />
    ),
  },
];

export const WEBINAR_DESCRIPTION_ITEMS = [
  'The labor shortage and employee retention strategies',
  'Material pricing and availability challenges',
  'Implementing technology and processes to gain efficiencies',
  'Building consistency in your business',
];

export const WEBINAR_PANELISTS_ITEMS = [
  {
    avatar: (
      <StaticImage
        src="../assets/images/webinar_panelist_3.jpg"
        alt="James Freeman"
      />
    ),
    name: 'James Freeman',
    role: 'CEO',
    company: 'PJ Fitzpatrick',
    key: 1,
  },
  {
    avatar: (
      <StaticImage
        src="../assets/images/webinar_panelist_1.jpg"
        alt="Paul Trautmann"
      />
    ),
    name: 'Paul Trautmann',
    role: 'President',
    company: 'Timberland Exteriors',
    key: 2,
  },
  {
    avatar: (
      <StaticImage
        src="../assets/images/webinar_panelist_2.jpg"
        alt="Marc Setty"
      />
    ),
    name: 'Marc Setty',
    role: 'DIRECTOR OF NORTH AMERICA REMODELING',
    company: 'JAMES HARDIE',
    key: 3,
  },
  {
    avatar: (
      <StaticImage
        src="../assets/images/webinar_panelist_4.jpg"
        alt="Kevin Sturm"
      />
    ),
    name: 'Kevin Sturm',
    role: 'HEAD OF PRODUCT MARKETING',
    company: 'HOVER',
    key: 4,
  },
];
